
import {useState, useEffect} from 'react';
import {LicenseClassGetPaging} from 'services/licenseClassService';
import {LicenseClass} from 'models/model';
import LoadingOverlay from "components/Static/LoadingOverlay";
import Pagination from "components/Pagination";
import { useHistory } from 'react-router-dom';
import { Edit } from 'lucide-react';

export default function TrainingPlantPage() {
    const [licenseClasses, setLicenseClasses] = useState<LicenseClass[]>([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [searchText, setSearchText] = useState("");
    const [pagination, setPagination] = useState({
        pageIndex: 1,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 1
    });
    const router = useHistory();

    const fetchLicenseClasses = async (pageIndex: number) => {
        try {
            setLoading(true);
            const response = await LicenseClassGetPaging({
                pageIndex,
                pageSize: pagination.pageSize,
                freeTextSearch: searchText
            });

            if (response.result) {
                setLicenseClasses(response.result.items);
                setPagination(prev => ({
                    ...prev,
                    pageIndex,
                    totalRecords: response.result.totalRecord,
                    totalPages: Math.ceil(response.result.totalRecord / pagination.pageSize)
                }));
            } else {
                setError(response.message || 'Failed to fetch license classes');
            }
        } catch (err) {
            setError('An error occurred while fetching license classes');
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        fetchLicenseClasses(1);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handlePageChange = (newPageIndex: number) => {
        if (newPageIndex < 1 || newPageIndex > pagination.totalPages) return;
        fetchLicenseClasses(newPageIndex);
    };

    const navigateToTrainingPlans = (id: string) => {
        router.push(`/training-plans/${id}`);
    };

    useEffect(() => {
        fetchLicenseClasses(1);
    }, []);

    return (
        <div className="bg-white rounded-lg shadow-md p-6">
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Kế hoạch đào tạo</h1>

            {/*/!* Search Section *!/*/}
            {/*<div className="flex items-center space-x-2 mr-4 mb-6">*/}
            {/*    <input*/}
            {/*        type="text"*/}
            {/*        placeholder="Tìm kiếm hạng..."*/}
            {/*        value={searchText}*/}
            {/*        onChange={(e) => setSearchText(e.target.value)}*/}
            {/*        onKeyDown={handleKeyDown}*/}
            {/*        className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none"*/}
            {/*    />*/}
            {/*    <Button*/}
            {/*        onClick={handleSearch}*/}
            {/*        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"*/}
            {/*    >*/}
            {/*        Tìm kiếm*/}
            {/*    </Button>*/}
            {/*</div>*/}

            {isLoading ? <LoadingOverlay message="Đang tải dữ liệu..."/> : (
                <div className="mx-auto">
                    <div className="grid grid-cols-1 gap-8">
                        <div className="bg-white rounded-lg shadow-md overflow-hidden">
                            <div className="w-full overflow-x-auto">

                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">STT</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Tên hạng
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Mô tả
                                        </th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider ">
                                            Chi tiết
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {licenseClasses.map((licenseClass, index) => (
                                        <tr
                                            key={licenseClass.id}
                                            className="hover:bg-gray-50 cursor-pointer"
                                            onClick={() => licenseClass.id && navigateToTrainingPlans(licenseClass.id)}
                                        >
                                            <td className="px-6 py-4 whitespace-nowrap text-center text-gray-500">
                                                {(pagination.pageIndex - 1) * pagination.pageSize + index + 1}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="font-medium text-gray-900">
                                                    Hạng: {licenseClass.name}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-gray-500">
                                                    {licenseClass.description || 'Chưa có mô tả'}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap ">
                                                <div className={'flex justify-end'}>
                                                    <button
                                                        className="text-blue-600 hover:text-blue-900 flex items-center "
                                                        title="Sửa"
                                                    >
                                                        <Edit className="inline me-0.5"/> <span className={'text-sm'}>Điều chỉnh kế hoạch</span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        {/* Pagination */}
                        <Pagination
                            pagination={pagination}
                            isLoading={isLoading}
                            onPageChange={handlePageChange}
                            label="hạng đào tạo"
                        />
                    </div>
                </div>
            )}
        </div>
    );
}